// Yofis — контракт API `yofis.v1`. Пользователь: профиль, устройства, присутствие, блокировки, жалобы.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/user.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Device, PageInfo, PresenceState, PushRegistration, User } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/user.proto.
 */
export const file_yofis_v1_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_yofis_v1_common]);

/**
 * Запрос своего профиля; полей нет.
 *
 * @generated from message yofis.v1.GetMeRequest
 */
export type GetMeRequest = Message<"yofis.v1.GetMeRequest"> & {
};

/**
 * Describes the message yofis.v1.GetMeRequest.
 * Use `create(GetMeRequestSchema)` to create a new message.
 */
export const GetMeRequestSchema: GenMessage<GetMeRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 0);

/**
 * Ответ со своим профилем.
 *
 * @generated from message yofis.v1.GetMeResponse
 */
export type GetMeResponse = Message<"yofis.v1.GetMeResponse"> & {
  /**
   * Мой профиль (`presence` не заполняется).
   *
   * @generated from field: yofis.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message yofis.v1.GetMeResponse.
 * Use `create(GetMeResponseSchema)` to create a new message.
 */
export const GetMeResponseSchema: GenMessage<GetMeResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 1);

/**
 * Частичное обновление своего профиля.
 *
 * @generated from message yofis.v1.UpdateMeRequest
 */
export type UpdateMeRequest = Message<"yofis.v1.UpdateMeRequest"> & {
  /**
   * Новые значения; читаются только поля из `update_mask`.
   *
   * @generated from field: yofis.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * Какие поля менять: `display_name`, `status_text`, `avatar_file_id`. Другие пути — invalid_argument.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message yofis.v1.UpdateMeRequest.
 * Use `create(UpdateMeRequestSchema)` to create a new message.
 */
export const UpdateMeRequestSchema: GenMessage<UpdateMeRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 2);

/**
 * Ответ на обновление профиля.
 *
 * @generated from message yofis.v1.UpdateMeResponse
 */
export type UpdateMeResponse = Message<"yofis.v1.UpdateMeResponse"> & {
  /**
   * Профиль после обновления.
   *
   * @generated from field: yofis.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message yofis.v1.UpdateMeResponse.
 * Use `create(UpdateMeResponseSchema)` to create a new message.
 */
export const UpdateMeResponseSchema: GenMessage<UpdateMeResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 3);

/**
 * Запрос профилей по адресам.
 *
 * @generated from message yofis.v1.GetUsersRequest
 */
export type GetUsersRequest = Message<"yofis.v1.GetUsersRequest"> & {
  /**
   * Адреса, до 100.
   *
   * @generated from field: repeated string addresses = 1;
   */
  addresses: string[];
};

/**
 * Describes the message yofis.v1.GetUsersRequest.
 * Use `create(GetUsersRequestSchema)` to create a new message.
 */
export const GetUsersRequestSchema: GenMessage<GetUsersRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 4);

/**
 * Ответ с профилями.
 *
 * @generated from message yofis.v1.GetUsersResponse
 */
export type GetUsersResponse = Message<"yofis.v1.GetUsersResponse"> & {
  /**
   * Найденные пользователи; порядок не гарантируется.
   *
   * @generated from field: repeated yofis.v1.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message yofis.v1.GetUsersResponse.
 * Use `create(GetUsersResponseSchema)` to create a new message.
 */
export const GetUsersResponseSchema: GenMessage<GetUsersResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 5);

/**
 * Поиск по справочнику.
 *
 * @generated from message yofis.v1.SearchUsersRequest
 */
export type SearchUsersRequest = Message<"yofis.v1.SearchUsersRequest"> & {
  /**
   * Подстрока имени, адреса, должности или отдела; пусто — весь справочник.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * Курсор страницы (§1.6).
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * Размер страницы; по умолчанию 50, максимум 200.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message yofis.v1.SearchUsersRequest.
 * Use `create(SearchUsersRequestSchema)` to create a new message.
 */
export const SearchUsersRequestSchema: GenMessage<SearchUsersRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 6);

/**
 * Ответ с результатами поиска.
 *
 * @generated from message yofis.v1.SearchUsersResponse
 */
export type SearchUsersResponse = Message<"yofis.v1.SearchUsersResponse"> & {
  /**
   * Пользователи с `presence`.
   *
   * @generated from field: repeated yofis.v1.User users = 1;
   */
  users: User[];

  /**
   * Пагинация.
   *
   * @generated from field: yofis.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message yofis.v1.SearchUsersResponse.
 * Use `create(SearchUsersResponseSchema)` to create a new message.
 */
export const SearchUsersResponseSchema: GenMessage<SearchUsersResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 7);

/**
 * Запрос своих устройств; полей нет.
 *
 * @generated from message yofis.v1.ListMyDevicesRequest
 */
export type ListMyDevicesRequest = Message<"yofis.v1.ListMyDevicesRequest"> & {
};

/**
 * Describes the message yofis.v1.ListMyDevicesRequest.
 * Use `create(ListMyDevicesRequestSchema)` to create a new message.
 */
export const ListMyDevicesRequestSchema: GenMessage<ListMyDevicesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 8);

/**
 * Ответ со списком устройств.
 *
 * @generated from message yofis.v1.ListMyDevicesResponse
 */
export type ListMyDevicesResponse = Message<"yofis.v1.ListMyDevicesResponse"> & {
  /**
   * Устройства; у текущего `current == true`.
   *
   * @generated from field: repeated yofis.v1.Device devices = 1;
   */
  devices: Device[];
};

/**
 * Describes the message yofis.v1.ListMyDevicesResponse.
 * Use `create(ListMyDevicesResponseSchema)` to create a new message.
 */
export const ListMyDevicesResponseSchema: GenMessage<ListMyDevicesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 9);

/**
 * Отзыв устройства.
 *
 * @generated from message yofis.v1.RevokeDeviceRequest
 */
export type RevokeDeviceRequest = Message<"yofis.v1.RevokeDeviceRequest"> & {
  /**
   * Идентификатор устройства.
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message yofis.v1.RevokeDeviceRequest.
 * Use `create(RevokeDeviceRequestSchema)` to create a new message.
 */
export const RevokeDeviceRequestSchema: GenMessage<RevokeDeviceRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 10);

/**
 * Ответ на отзыв устройства; полей нет.
 *
 * @generated from message yofis.v1.RevokeDeviceResponse
 */
export type RevokeDeviceResponse = Message<"yofis.v1.RevokeDeviceResponse"> & {
};

/**
 * Describes the message yofis.v1.RevokeDeviceResponse.
 * Use `create(RevokeDeviceResponseSchema)` to create a new message.
 */
export const RevokeDeviceResponseSchema: GenMessage<RevokeDeviceResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 11);

/**
 * Обновление push-регистрации текущего устройства.
 *
 * @generated from message yofis.v1.UpdatePushRegistrationRequest
 */
export type UpdatePushRegistrationRequest = Message<"yofis.v1.UpdatePushRegistrationRequest"> & {
  /**
   * Новая регистрация; `provider = UNSPECIFIED` — invalid_argument (отключение — `RemovePushRegistration`).
   *
   * @generated from field: yofis.v1.PushRegistration push = 1;
   */
  push?: PushRegistration | undefined;
};

/**
 * Describes the message yofis.v1.UpdatePushRegistrationRequest.
 * Use `create(UpdatePushRegistrationRequestSchema)` to create a new message.
 */
export const UpdatePushRegistrationRequestSchema: GenMessage<UpdatePushRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 12);

/**
 * Ответ на обновление push-регистрации; полей нет.
 *
 * @generated from message yofis.v1.UpdatePushRegistrationResponse
 */
export type UpdatePushRegistrationResponse = Message<"yofis.v1.UpdatePushRegistrationResponse"> & {
};

/**
 * Describes the message yofis.v1.UpdatePushRegistrationResponse.
 * Use `create(UpdatePushRegistrationResponseSchema)` to create a new message.
 */
export const UpdatePushRegistrationResponseSchema: GenMessage<UpdatePushRegistrationResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 13);

/**
 * Отключение push на текущем устройстве; полей нет.
 *
 * @generated from message yofis.v1.RemovePushRegistrationRequest
 */
export type RemovePushRegistrationRequest = Message<"yofis.v1.RemovePushRegistrationRequest"> & {
};

/**
 * Describes the message yofis.v1.RemovePushRegistrationRequest.
 * Use `create(RemovePushRegistrationRequestSchema)` to create a new message.
 */
export const RemovePushRegistrationRequestSchema: GenMessage<RemovePushRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 14);

/**
 * Ответ на отключение push; полей нет.
 *
 * @generated from message yofis.v1.RemovePushRegistrationResponse
 */
export type RemovePushRegistrationResponse = Message<"yofis.v1.RemovePushRegistrationResponse"> & {
};

/**
 * Describes the message yofis.v1.RemovePushRegistrationResponse.
 * Use `create(RemovePushRegistrationResponseSchema)` to create a new message.
 */
export const RemovePushRegistrationResponseSchema: GenMessage<RemovePushRegistrationResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 15);

/**
 * Установка присутствия.
 *
 * @generated from message yofis.v1.SetPresenceRequest
 */
export type SetPresenceRequest = Message<"yofis.v1.SetPresenceRequest"> & {
  /**
   * ONLINE, AWAY или HIDDEN; OFFLINE и UNSPECIFIED — invalid_argument.
   *
   * @generated from field: yofis.v1.PresenceState state = 1;
   */
  state: PresenceState;
};

/**
 * Describes the message yofis.v1.SetPresenceRequest.
 * Use `create(SetPresenceRequestSchema)` to create a new message.
 */
export const SetPresenceRequestSchema: GenMessage<SetPresenceRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 16);

/**
 * Ответ на установку присутствия; полей нет.
 *
 * @generated from message yofis.v1.SetPresenceResponse
 */
export type SetPresenceResponse = Message<"yofis.v1.SetPresenceResponse"> & {
};

/**
 * Describes the message yofis.v1.SetPresenceResponse.
 * Use `create(SetPresenceResponseSchema)` to create a new message.
 */
export const SetPresenceResponseSchema: GenMessage<SetPresenceResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 17);

/**
 * Блокировка пользователя.
 *
 * @generated from message yofis.v1.BlockUserRequest
 */
export type BlockUserRequest = Message<"yofis.v1.BlockUserRequest"> & {
  /**
   * Адрес пользователя.
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message yofis.v1.BlockUserRequest.
 * Use `create(BlockUserRequestSchema)` to create a new message.
 */
export const BlockUserRequestSchema: GenMessage<BlockUserRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 18);

/**
 * Ответ на блокировку; полей нет.
 *
 * @generated from message yofis.v1.BlockUserResponse
 */
export type BlockUserResponse = Message<"yofis.v1.BlockUserResponse"> & {
};

/**
 * Describes the message yofis.v1.BlockUserResponse.
 * Use `create(BlockUserResponseSchema)` to create a new message.
 */
export const BlockUserResponseSchema: GenMessage<BlockUserResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 19);

/**
 * Снятие блокировки.
 *
 * @generated from message yofis.v1.UnblockUserRequest
 */
export type UnblockUserRequest = Message<"yofis.v1.UnblockUserRequest"> & {
  /**
   * Адрес пользователя.
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message yofis.v1.UnblockUserRequest.
 * Use `create(UnblockUserRequestSchema)` to create a new message.
 */
export const UnblockUserRequestSchema: GenMessage<UnblockUserRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 20);

/**
 * Ответ на снятие блокировки; полей нет.
 *
 * @generated from message yofis.v1.UnblockUserResponse
 */
export type UnblockUserResponse = Message<"yofis.v1.UnblockUserResponse"> & {
};

/**
 * Describes the message yofis.v1.UnblockUserResponse.
 * Use `create(UnblockUserResponseSchema)` to create a new message.
 */
export const UnblockUserResponseSchema: GenMessage<UnblockUserResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 21);

/**
 * Запрос списка заблокированных; полей нет.
 *
 * @generated from message yofis.v1.ListBlockedUsersRequest
 */
export type ListBlockedUsersRequest = Message<"yofis.v1.ListBlockedUsersRequest"> & {
};

/**
 * Describes the message yofis.v1.ListBlockedUsersRequest.
 * Use `create(ListBlockedUsersRequestSchema)` to create a new message.
 */
export const ListBlockedUsersRequestSchema: GenMessage<ListBlockedUsersRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 22);

/**
 * Ответ со списком заблокированных.
 *
 * @generated from message yofis.v1.ListBlockedUsersResponse
 */
export type ListBlockedUsersResponse = Message<"yofis.v1.ListBlockedUsersResponse"> & {
  /**
   * Адреса заблокированных мною пользователей.
   *
   * @generated from field: repeated string addresses = 1;
   */
  addresses: string[];
};

/**
 * Describes the message yofis.v1.ListBlockedUsersResponse.
 * Use `create(ListBlockedUsersResponseSchema)` to create a new message.
 */
export const ListBlockedUsersResponseSchema: GenMessage<ListBlockedUsersResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 23);

/**
 * Жалоба.
 *
 * @generated from message yofis.v1.ReportRequest
 */
export type ReportRequest = Message<"yofis.v1.ReportRequest"> & {
  /**
   * На кого или на что.
   *
   * @generated from field: yofis.v1.ReportTarget target = 1;
   */
  target?: ReportTarget | undefined;

  /**
   * Причина.
   *
   * @generated from field: yofis.v1.ReportReason reason = 2;
   */
  reason: ReportReason;

  /**
   * Комментарий пользователя; опционально.
   *
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message yofis.v1.ReportRequest.
 * Use `create(ReportRequestSchema)` to create a new message.
 */
export const ReportRequestSchema: GenMessage<ReportRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 24);

/**
 * Цель жалобы: пользователь или сообщение.
 *
 * @generated from message yofis.v1.ReportTarget
 */
export type ReportTarget = Message<"yofis.v1.ReportTarget"> & {
  /**
   * Ровно одно из.
   *
   * @generated from oneof yofis.v1.ReportTarget.target
   */
  target: {
    /**
     * Адрес пользователя.
     *
     * @generated from field: string user_address = 1;
     */
    value: string;
    case: "userAddress";
  } | {
    /**
     * Сообщение в чате.
     *
     * @generated from field: yofis.v1.MessageRef message = 2;
     */
    value: MessageRef;
    case: "message";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yofis.v1.ReportTarget.
 * Use `create(ReportTargetSchema)` to create a new message.
 */
export const ReportTargetSchema: GenMessage<ReportTarget> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 25);

/**
 * Ссылка на сообщение: чат + сообщение.
 *
 * @generated from message yofis.v1.MessageRef
 */
export type MessageRef = Message<"yofis.v1.MessageRef"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Идентификатор сообщения.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;
};

/**
 * Describes the message yofis.v1.MessageRef.
 * Use `create(MessageRefSchema)` to create a new message.
 */
export const MessageRefSchema: GenMessage<MessageRef> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 26);

/**
 * Ответ на жалобу; полей нет.
 *
 * @generated from message yofis.v1.ReportResponse
 */
export type ReportResponse = Message<"yofis.v1.ReportResponse"> & {
};

/**
 * Describes the message yofis.v1.ReportResponse.
 * Use `create(ReportResponseSchema)` to create a new message.
 */
export const ReportResponseSchema: GenMessage<ReportResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_user, 27);

/**
 * Причина жалобы. Набор не задан в документе 12 — предложен минимальный, расширяется аддитивно.
 *
 * @generated from enum yofis.v1.ReportReason
 */
export enum ReportReason {
  /**
   * Не задана.
   *
   * @generated from enum value: REPORT_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Спам, реклама.
   *
   * @generated from enum value: REPORT_REASON_SPAM = 1;
   */
  SPAM = 1,

  /**
   * Оскорбления, травля.
   *
   * @generated from enum value: REPORT_REASON_HARASSMENT = 2;
   */
  HARASSMENT = 2,

  /**
   * Запрещённый контент.
   *
   * @generated from enum value: REPORT_REASON_ILLEGAL_CONTENT = 3;
   */
  ILLEGAL_CONTENT = 3,

  /**
   * Другое — см. `comment`.
   *
   * @generated from enum value: REPORT_REASON_OTHER = 4;
   */
  OTHER = 4,
}

/**
 * Describes the enum yofis.v1.ReportReason.
 */
export const ReportReasonSchema: GenEnum<ReportReason> = /*@__PURE__*/
  enumDesc(file_yofis_v1_user, 0);

/**
 * Профиль и настройки текущего пользователя, справочник узла. Уровень всех методов — signed.
 *
 * @generated from service yofis.v1.UserService
 */
export const UserService: GenService<{
  /**
   * Мой профиль.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.GetMe
   */
  getMe: {
    methodKind: "unary";
    input: typeof GetMeRequestSchema;
    output: typeof GetMeResponseSchema;
  },
  /**
   * Частичное обновление профиля: `display_name`, `status_text`, `avatar_file_id`.
   * `title` и `department` пользователь не правит — только `AdminService.UpdateUserProfile` или SSO/LDAP.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.UpdateMe
   */
  updateMe: {
    methodKind: "unary";
    input: typeof UpdateMeRequestSchema;
    output: typeof UpdateMeResponseSchema;
  },
  /**
   * Профили по адресам, до 100 за раз; неизвестные адреса пропускаются.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.GetUsers
   */
  getUsers: {
    methodKind: "unary";
    input: typeof GetUsersRequestSchema;
    output: typeof GetUsersResponseSchema;
  },
  /**
   * Поиск по справочнику узла (`Capabilities.user_directory`); гости справочник не видят.
   * Уровень: signed. Ошибки: CAPABILITY_DISABLED.
   *
   * @generated from rpc yofis.v1.UserService.SearchUsers
   */
  searchUsers: {
    methodKind: "unary";
    input: typeof SearchUsersRequestSchema;
    output: typeof SearchUsersResponseSchema;
  },
  /**
   * Мои устройства.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.ListMyDevices
   */
  listMyDevices: {
    methodKind: "unary";
    input: typeof ListMyDevicesRequestSchema;
    output: typeof ListMyDevicesResponseSchema;
  },
  /**
   * Отозвать устройство: его сессии закрываются, ключ удаляется, устройство получает `DeviceRevoked`.
   * Текущее устройство отозвать нельзя — используйте `AuthService.Logout`.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.RevokeDevice
   */
  revokeDevice: {
    methodKind: "unary";
    input: typeof RevokeDeviceRequestSchema;
    output: typeof RevokeDeviceResponseSchema;
  },
  /**
   * Обновить push-регистрацию текущего устройства (смена токена провайдера). `provider = UNSPECIFIED` — invalid_argument.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.UpdatePushRegistration
   */
  updatePushRegistration: {
    methodKind: "unary";
    input: typeof UpdatePushRegistrationRequestSchema;
    output: typeof UpdatePushRegistrationResponseSchema;
  },
  /**
   * Отключить push на текущем устройстве (0.4).
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.RemovePushRegistration
   */
  removePushRegistration: {
    methodKind: "unary";
    input: typeof RemovePushRegistrationRequestSchema;
    output: typeof RemovePushRegistrationResponseSchema;
  },
  /**
   * Установить своё присутствие: ONLINE, AWAY или HIDDEN. OFFLINE ставит сервер по разрыву стрима.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.SetPresence
   */
  setPresence: {
    methodKind: "unary";
    input: typeof SetPresenceRequestSchema;
    output: typeof SetPresenceResponseSchema;
  },
  /**
   * Заблокировать пользователя: он не может писать мне и звонить; мне не приходят его сообщения в DIRECT.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.BlockUser
   */
  blockUser: {
    methodKind: "unary";
    input: typeof BlockUserRequestSchema;
    output: typeof BlockUserResponseSchema;
  },
  /**
   * Снять блокировку.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.UnblockUser
   */
  unblockUser: {
    methodKind: "unary";
    input: typeof UnblockUserRequestSchema;
    output: typeof UnblockUserResponseSchema;
  },
  /**
   * Кого я заблокировал.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.ListBlockedUsers
   */
  listBlockedUsers: {
    methodKind: "unary";
    input: typeof ListBlockedUsersRequestSchema;
    output: typeof ListBlockedUsersResponseSchema;
  },
  /**
   * Пожаловаться на пользователя или сообщение; жалоба уходит администраторам узла.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.UserService.Report
   */
  report: {
    methodKind: "unary";
    input: typeof ReportRequestSchema;
    output: typeof ReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_user, 0);

